import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { IDemographyDetails } from '../models/ProspectModel';
import { ECallScriptForms } from '../enum';

@Component({
    selector: 'app-demographic',
    templateUrl: './demographic.component.html',
    styleUrls: ['./demographic.component.scss'],
    standalone: false
})

export class DemographicComponent implements OnInit {
    @Input() section;
    @Output() emitSaveDemoCallScript: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitChangedScript: EventEmitter<any> = new EventEmitter<any>();

    @Output() closeDemographicView: EventEmitter<any> = new EventEmitter<any>();
    @Output() demographicInfo: EventEmitter<any> = new EventEmitter<any>();
    @Input() unitDetailsInfo;
    @Input() facilityIdfromQuickStart;
    @Output() isMarketingDirty: EventEmitter<any> = new EventEmitter<any>();
    @Input() isFromQuickstartRentUnit: boolean = false;
    selectedOption = 0;
    isDirty = false;
    demographicResponse: IDemographyDetails[];
    demographicList = [];
    modalRef: BsModalRef;

    constructor(private prospectService: ProspectService,
        private modalService: BsModalService,
        private facOpsDataService: FacOpsDataService) { }

    ngOnInit() {
        if (this.getDemographyService === undefined || this.getDemographyService === null) {
            const facId = (this.unitDetailsInfo) ? this.unitDetailsInfo.FacilityId : this.facilityIdfromQuickStart;
            this.getMarketingList(facId);
        } else {
            this.demographicList = JSON.parse(JSON.stringify(this.getDemographyService));
        }

        this.facOpsDataService.scriptIndex$.subscribe(({ section, index }) => {
            if (section !== this.section || this.facOpsDataService.onPageOpen) {
                return;
            }
            this.onScriptChange();
        });
    }

    getMarketingList(facilityId) {
        this.demographicList = this.demographicList || [];
        this.prospectService.GetDempographicDetails(facilityId)
            .subscribe((response: IDemographyDetails[]) => {
                this.demographicResponse = response;
                if (response.length === 0) {
                    this.isMarketingDirty.emit(true);
                }
                for (let i = 0; i < this.demographicResponse.length; i++) {
                    const obj = {
                        Id: this.demographicResponse[i].Id,
                        Question: this.demographicResponse[i].Question,
                        Option: this.demographicResponse[i].MarketingOptions.sort((a, b) => a.DisplayOrder - b.DisplayOrder),
                        isDemographic: this.demographicResponse[i].Demographic,
                        DisplayOrder: this.demographicResponse[i].DisplayOrder
                    };
                    this.demographicList.push(obj);
                    this.demographicList.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
                    if (this.unitDetailsInfo) {
                        if (this.unitDetailsInfo.Demography) {
                            this.unitDetailsInfo.Demography.map(item => {
                                this.demographicList.map(ele => {
                                    ele.Option.forEach(opt => {
                                        if (opt.OptionId == item.OptionId) {
                                            opt['selected'] = item.OptionId;
                                            opt['checked'] = true;
                                        }
                                    });
                                });
                            });
                        }
                    }
                }
            },
            );
    }

    optionChecked(event, option) {
        this.isDirty = true;
        this.isMarketingDirty.emit(true);
        if (event.target.checked === true) {
            option['checked'] = true;
        } else if (event.target.checked === false) {
            option['checked'] = false;
        }
    }

    onSelectOption(optionId, item) {
        this.isDirty = true;
        this.isMarketingDirty.emit(true);
        item.Option.forEach((element) => {
            if (element.OptionId === parseInt(optionId)) {
                element['selected'] = optionId;
            } else {
                element['selected'] = 0;
            }
        });
    }

    HideDemographic() {
        this.closeDemographicView.emit(false);
        this.setDemographyService = this.getDemographyService;
        this.modalRef.hide();
    }

    saveDemographic() {
        this.setDemographyService = JSON.parse(JSON.stringify(this.demographicList));
        this.demographicInfo.emit(this.demographicList);
        this.closeDemographicView.emit(true);
        this.isDirty = false;
    }

    get getDemographyService() {
        return this.facOpsDataService.demographyInfo;
    }
    set setDemographyService(value) {
        this.facOpsDataService.demographyInfo = value;
    }

    openModal(template: TemplateRef<any>) {
        this.modalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }

    cancelDemographic(template: TemplateRef<any>) {
        if (this.isDirty === true) {
            this.openModal(template);
        } else {
            this.closeDemographicView.emit(false);
        }
    }

    onScriptChange() {
        let script = this.facOpsDataService.getScript(this.section);
        if (!script || !script.FormId || script.FormId == ECallScriptForms['Prospect/Reservation/Rental : Demographyphy']
        || (script.firstTimeCalled && !script.buttonNavigate)) {
            return;
        }
        script.firstTimeCalled = true;
        if (this.isDirty) {
            this.setDemographyService = JSON.parse(JSON.stringify(this.demographicList));
            this.emitSaveDemoCallScript.emit(this.demographicList);
            this.isDirty = false;
        }
        this.emitChangedScript.emit(script);
    }
}

